// CROSSSELL-109 — Store V2 UI copy (UA / EN). No Russian UI labels.

import type { StoreV2Lang } from "./store-v2-locale.js";

const UA = {
  back: "← Назад",
  home: "Головна",
  cart: "Кошик",
  profile: "Про магазин і продавця",
  my_cabinet: "Мій кабінет",
  store_sku: "Артикул магазину",
  original_sku: "Оригінальний SKU",
  change_payment_method: "Змінити спосіб оплати",
  abandon_payment: "Відмінити оплату",
  continue_payment: "Продовжити оплату",
  payment_taking_longer: "Платіж займає більше часу, ніж очікувалось",
  payment_preparing_novapay: "Готуємо захищену сторінку оплати…",
  payment_novapay_slow: "Онлайн-оплата відповідає довше, ніж очікувалося.",
  payment_novapay_processing: "Онлайн-оплата ще обробляється",
  payment_novapay_processing_body:
    "Ми не отримали остаточного результату від платіжної системи. Не повторюйте оплату, щоб уникнути подвійного списання.",
  payment_novapay_degraded_title: "Онлайн-оплата карткою",
  payment_novapay_degraded_state: "Тимчасово недоступна у тестовому середовищі",
  payment_novapay_degraded_body:
    "Онлайн-оплата затримує завершення тестових платежів. Оберіть інший спосіб — замовлення та товари збережуться.",
  payment_novapay_not_live_title: "⚡ Онлайн-оплата карткою",
  payment_novapay_not_live_state: "Ще активується",
  payment_novapay_not_live_body:
    "Онлайн-оплата карткою ще активується. Поки що оплатіть на рахунок (IBAN).",
  payment_novapay_use_fop_fallback: "Оплатити на рахунок (IBAN)",
  payment_retry: "Спробувати ще раз",
  check_payment_status: "Перевірити статус оплати",
  return_to_order: "Повернутися до замовлення",
  cancel_order: "Скасувати замовлення",
  payment_section: "Оплата",
  fop_payment_option: "Оплата на рахунок (IBAN)",
  bank_method_title: "Банківський переказ (IBAN)",
  copied_short: "Скопійовано",
  bank_awaiting_confirmation: "Очікуємо оплату",
  bank_awaiting_body:
    "Після оплати ми автоматично перевіримо надходження коштів. Зазвичай підтвердження з’являється протягом кількох хвилин.",
  bank_paid_title: "✓ Оплату підтверджено банком",
  bank_paid_body: "",
  bank_pay_via_bank: "🏦 Оплатити через застосунок банку",
  bank_retry_open: "🏦 Оплатити через застосунок банку",
  bank_open_full_page: "Відкрити повну сторінку оплати",
  bank_create_and_pay: "Створити замовлення · {TOTAL} ₴",
  bank_create_reorder: "Створити повторне замовлення · {TOTAL} ₴",
  reorder_cart_added: "Товари з замовлення {STG} додано до кошика",
  reorder_cart_merged: "Кошик оновлено",
  reorder_item_unavailable: "Цього товару зараз немає в наявності",
  reorder_comment_hint: "Коментар з попереднього замовлення не переноситься автоматично.",
  add_order_comment: "💬 Додати коментар до замовлення",
  pay_after_create: "Оплатити після створення",
  pay_after_create_subcopy: "Реквізити доступні одразу",
  confirm_availability_first: "Спочатку підтвердити наявність",
  confirm_availability_first_subcopy: "Менеджер перевірить товар",
  checkout_cta_bank_title: "Створити замовлення і сплатити в застосунку банку",
  checkout_cta_bank_amount: "До сплати: {TOTAL} ₴",
  checkout_cta_confirm_title: "Спочатку підтвердити наявність",
  checkout_cta_confirm_amount: "Створити замовлення на {TOTAL} ₴",
  checkout_cta_manager_review_title: "Створити замовлення з перевіркою менеджером",
  checkout_stock_review_title: "Потрібне підтвердження наявності",
  checkout_stock_review_body:
    "У кошику є товари, наявність яких потрібно підтвердити. Менеджер перевірить замовлення перед оплатою.",
  payment_timing_section: "Коли оплачувати",
  copy_all_done: "✓ Реквізити скопійовано",
  documents_section: "📄 Документи",
  documents_pending: "Документи ще не сформовано",
  bank_awaiting_stock: "Очікуємо підтвердження наявності",
  bank_awaiting_stock_body:
    "Менеджер перевірить наявність товарів і повідомлять, коли можна оплатити.",
  bank_checking_payment: "Перевіряємо оплату…",
  bank_still_checking:
    "Платіж ще перевіряється. Це може зайняти кілька хвилин.",
  bank_refresh_status: "Перевірити оплату",
  bank_open_app: "Відкрити застосунок банку",
  bank_handoff_failed: "Не вдалося автоматично відкрити застосунок банку",
  bank_awaiting_credit: "Очікуємо зарахування платежу",
  bank_awaiting_credit_body: "Зазвичай підтвердження займає трохи часу.",
  bank_timeline_created: "Замовлення створено",
  bank_timeline_awaiting: "Оплату очікуємо",
  bank_timeline_confirmed: "Оплату підтверджено",
  bank_chooser_title: "Оберіть банк для оплати",
  bank_fixed_method_hint:
    "Оплата надходить безпосередньо на поточний рахунок продавця.",
  bank_fixed_method_launch: "Реквізити автоматично передадуться у банківський застосунок.",
  bank_fixed_method_direct: "Оплата надходить безпосередньо на поточний рахунок продавця.",
  checkout_contact_delivery: "Контакт і доставка",
  checkout_save_to_cabinet: "Зберегти цю адресу в моєму кабінеті",
  save: "Зберегти",
  checkout_add_more: "🔎 Додати товар",
  checkout_add_order: "Додайте до замовлення",
  checkout_add_other: "Додати інший товар",
  creating_order: "Створюємо замовлення…",
  cart_add_product: "Додати товар",
  cart_search_placeholder: "🔎 Знайти товар",
  cart_add_hit: "+ Додати",
  cart_added: "✓ Додано",
  my_orders: "📦 Мої замовлення",
  view_order: "📦 Переглянути замовлення",
  compact_referral_title: "🎁 Поділіться «Скарбами Азії»",
  compact_referral_body: "Запросіть друзів, яким теж цікаві азійські продукти.",
  compact_referral_cta: "Запросити друзів",
  cart_show_all_results: "Показати всі результати",
  amount_to_pay: "До сплати",
  consent_before_start: "Перед початком",
  consent_accept_continue: "Погоджуюся та продовжити",
  consent_decline: "Не погоджуюся",
  consent_decline_title: "Магазин недоступний без згоди",
  consent_decline_body:
    "Щоб оформити замовлення, потрібно прийняти умови. Ви можете закрити застосунок і повернутися пізніше.",
  legal_offer_btn: "📄 Публічна оферта",
  legal_privacy_btn: "🔒 Політика конфіденційності",
  fop_send_receipt_manager: "📎 Прикріпити квитанцію",
  cod_payment_option: "Післяплата у Новій пошті",
  confirm_abandon_processing_title: "Онлайн-оплата ще обробляється",
  confirm_abandon_processing_body:
    "Якщо зміните спосіб оплати зараз, попередня спроба залишиться в обробці. Не повторюйте карткову оплату. Продовжити?",
  confirm_abandon_processing_yes: "Так, змінити спосіб",
  confirm_abandon_processing_no: "Скасувати",
  reason_label: "Причина",
  write_manager_primary: "Написати менеджеру",
  product: "Товар",
  checkout: "Оформлення",
  success: "Замовлення створено",
  success_awaiting_payment: "Очікуємо оплату",
  success_awaiting_payment_body: "Завершіть оплату, щоб ми могли зібрати замовлення.",
  success_verifying_title: "Підтверджуємо оплату",
  success_verifying_body:
    "Отримали повернення з оплати. Перевіряємо статус платежу.",
  success_preparing_title: "Готуємо захищену оплату",
  success_preparing_body: "Створюємо платіж і відкриваємо захищену сторінку.",
  fulfillment_preparing: "Готуємо замовлення до відправлення",
  fulfillment_manager_pending: "Очікує підтвердження магазину",
  fulfillment_order_created: "Замовлення створено",
  success_paid_title: "Оплату підтверджено ✓",
  success_fop_title: "Замовлення створено",
  success_fop_status: "Очікуємо підтвердження банку",
  success_fop_receipt_title: "Квитанцію надіслано",
  success_fop_receipt_status: "Очікуємо перевірки менеджером",
  success_cod_title: "Замовлення підтверджено",
  success_cod_status: "Оплата — під час отримання у Новій пошті.",
  success_cod_payment_row: "Оплата — під час отримання у Новій пошті.",
  fop_send_receipt: "📎 Прикріпити квитанцію",
  fop_send_receipt_hint: "Необов’язково — квитанція буде збережена в замовленні.",
  fop_send_receipt_hint_paid: "Необов’язково — квитанція буде збережена в замовленні.",
  fop_after_pay_instruction:
    "Після оплати ми автоматично перевіримо надходження коштів. Зазвичай підтвердження з’являється протягом кількох хвилин.",
  send_requisites_chat: "✈️ Надіслати реквізити в чат",
  requisites_sent_chat: "✓ Реквізити надіслано в чат",
  request_cancellation: "Запросити скасування",
  fop_payment_status_label: "Статус оплати",
  fop_next_step_manager: "Підтвердження менеджером",
  fop_receipt_sent: "✅ Квитанцію отримано",
  fop_awaiting_manager:
    "Вона допоможе менеджеру перевірити платіж. Статус оплати зміниться після підтвердження фактичного зарахування.",
  fop_checking_file: "Перевіряємо файл…",
  referral_reward_pending:
    "Нагорода за рефералку стане доступною після успішного виконання замовлення та anti-fraud перевірки.",
  payment_help: "Допомога з оплатою",
  help_feedback: "Допомога",
  report_bug: "Повідомити про помилку",
  suggest_improvement: "Запропонувати покращення",
  feedback_bug_hint: "Коротко опишіть, що сталося. Технічні деталі зберемо автоматично.",
  feedback_improve_hint: "Напишіть, що можна покращити.",
  feedback_comment_placeholder: "Ваш коментар (необовʼязково для помилки)",
  feedback_send: "Надіслати",
  feedback_thanks: "Дякуємо. Повідомлення надіслано менеджеру.",
  feedback_send_fail: "Не вдалося надіслати. Спробуйте ще раз.",
  back_to_order: "Повернутися до замовлення",
  category: "Категорія",
  search: "Пошук",
  empty_cart: "Кошик порожній",
  empty_cart_hint: "Додайте товари з каталогу.",
  to_catalog: "До каталогу →",
  promo: "🎁 Промокод",
  promo_placeholder: "Введіть промокод",
  apply: "Застосувати",
  remove: "Прибрати",
  applied: "Застосовано",
  promo_invalid: "Промокод недійсний.",
  promo_under_min: "Промокод діє від {min}. Додайте товарів.",
  delete: "Видалити",
  sku: "Артикул магазину",
  barcode: "Штрихкод",
  checkout_cta: "Оформити замовлення",
  continue_shopping: "Продовжити покупки",
  subtotal: "Підсумок",
  discount: "Знижка",
  total: "Разом",
  add_to_cart: "+ Додати в кошик",
  unavailable: "Недоступно",
  out_of_stock: "Немає в наявності",
  in_cart: "У кошику",
  go_cart: "Перейти",
  to_cart: "У кошику · Перейти",
  countries: "Країни",
  countries_hint: "Кухні та смаки Азії",
  country_filter_meaning: "Фільтр за кухнею / позиціонуванням (не країна виробництва)",
  brand_country_label: "Країна бренду",
  cuisine_country_label: "Кухня / позиціонування",
  active_in_stock: "В наявності",
  brand_logo_fallback: "Логотип недоступний",
  welcome_back: "Вітаємо знову! Оберіть улюблені товари або продовжіть покупки.",
  price_tbd: "Ціна уточнюється",
  oos: "Товар тимчасово відсутній. Ми повідомимо, коли він з’явиться.",
  unpriced: "Ціна уточнюється — цей товар поки не можна додати в кошик. Напишіть менеджеру.",
  brand: "Бренд",
  country: "Країна",
  weight: "Обʼєм / вага",
  product_code: "Артикул",
  lang: "Мова",
  lang_ua: "UA",
  lang_en: "EN",
  crosssell_title: "Доповнити замовлення",
  recs_show_others: "Показати інші товари",
  crosssell_sub: "Ці товари часто купують разом",
  crosssell_add: "+ Додати",
  added_toast: "Товар додано в кошик",
  added_btn: "Додано ✓",
  pairs_well: "З цим товаром купують",
  may_like: "Може сподобатися",
  recently_viewed: "Ви нещодавно переглядали",
  low_stock: "Мало",
  thank_you: "Дякуємо за замовлення!",
  manager_soon: "Менеджер звʼяжеться з вами найближчим часом.",
  order_number: "Номер замовлення:",
  to_home: "На головну",
  write_manager: "✍️ Написати менеджеру",
  delete_data: "🗑️ Видалити мої дані",
  delete_ack: "Запит прийнято. Менеджер обробить його.",
  catalog_load_fail: "Не вдалося завантажити магазин",
  catalog_load_fail_title: "Не вдалося завантажити магазин.",
  retry: "Спробувати ще раз",
  loading: "Завантажуємо магазин…",
  loading_brand_title: "Скарби вже близько",
  results: "Результати",
  nothing_found: "Нічого не знайдено",
  nothing_hint: "Спробуйте інший запит: томям, рамен, соус, нори.",
  empty_category: "У цій категорії поки немає товарів",
  empty_category_hint: "Спробуйте іншу категорію або пошук.",
  build: "Збірка",
  catalog: "Каталог",
  phone: "Телефон",
  hours: "Графік",
  day_off: "Вихідний",
  monday: "Понеділок",
  about: "Про магазин",
  contact_manager: "Зв'язатися з менеджером",
  close: "Закрити",
  call: "Подзвонити",
  copied: "Скопійовано ✓",
  copy: "Скопіювати",
  copy_all: "Скопіювати всі реквізити",
  copy_manually: "Скопіюйте вручну",
  new_arrivals: "Нові надходження",
  new_arrivals_hint: "Свіжі товари та новинки",
  dropshipping: "Дропшипінг",
  dropshipping_hint: "Продавайте без власного складу",
  brands: "Бренди",
  brands_hint: "Знайти за виробником",
  cart_cta_go: "У кошику: {qty} · Перейти",
  pay_online: "Оплата онлайн",
  pay_bank_transfer: "Оплата на рахунок (IBAN)",
  pay_cod: "Післяплата у відділенні",
  pay_online_unavailable: "Онлайн-оплата тимчасово недоступна. Оберіть інший спосіб оплати.",
  brand_search: "Пошук брендів",
  products: "товарів",
  availability_request: "Запитати наявність",
  did_you_mean: "Можливо, ви шукали «{q}»?",
  maybe_sku: "Можливо, ви шукали SKU {q}?",
  available: "В наявності",
  not_available: "Немає в наявності",
  availability_unknown: "Наявність уточнюється",
  checkout_contact: "Контакти",
  checkout_payment: "Оплата",
  checkout_confirm: "Підтвердження",
  next_payment: "Далі → Оплата",
  next_confirm: "Далі → Підтвердження",
  first_name: "Імʼя",
  last_name: "Прізвище",
  city_np: "Місто (Нова Пошта)",
  warehouse: "Відділення",
  note: "Коментар",
  optional: "За бажанням",
  choose_payment: "Оберіть спосіб оплати",
  fop_payment: "Оплата на рахунок (IBAN)",
  cod_payment: "Післяплата у Новій пошті",
  cod_hint:
    "Хочете заощадити на додатковій комісії?\n\nОплатіть замовлення на рахунок ФОП і не сплачуйте окрему комісію за переказ післяплати. Під час оплати при отриманні Нова пошта додатково стягує комісію відповідно до чинних тарифів.",
  novapay_placeholder: "Карткою — незабаром",
  novapay_pay_card: "⚡ Онлайн-оплата карткою",
  novapay_sandbox_badge_title: "TEST / SANDBOX · НЕ БОЙОВА ОПЛАТА",
  novapay_sandbox_badge_body: "Тестова оплата. Реальні кошти не списуються.",
  novapay_helper: "Картка · Apple Pay · Google Pay",
  novapay_helper_note:
    "Оплата на захищеній сторінці. Доступні способи залежать від пристрою.",
  recipient: "Отримувач",
  delivery: "Доставка",
  payment: "Оплата",
  amount: "Сума",
  amount_due: "До сплати",
  submit_order: "Підтвердити замовлення",
  submitting: "Надсилаємо…",
  agreement_details: "Детальніше",
  agree: "Погоджуюся",
  seller: "Продавець",
  tax_id: "РНОКПП / ІПН",
  bank: "Банк",
  address: "Адреса",
  working_hours:
    "Графік роботи: Вт–Нд, 09:00–18:00. Пн — вихідний. Замовлення, отримані після 18:00 або у вихідний, опрацьовуємо за можливості; інакше — найближчого робочого дня.",
  clear_cart: "Очистити кошик",
  clear_cart_title: "Очистити кошик?",
  clear_cart_body: "Усі товари буде видалено з кошика.",
  clear_cart_confirm: "Очистити",
  cancel: "Скасувати",
  cart_cleared: "Кошик очищено ✓",
  checkout_revalidate_fail:
    "Не вдалося перевірити актуальні ціни та наявність. Кошик збережено. Спробуйте ще раз.",
  try_again: "Спробувати ще раз",
  price_changed_hint: "Ціну оновлено за каталогом. Перевірте нову суму перед підтвердженням.",
} as const;

const EN: Record<keyof typeof UA, string> = {
  back: "← Back",
  home: "Home",
  cart: "Cart",
  profile: "About store & seller",
  my_cabinet: "My cabinet",
  store_sku: "Store SKU",
  original_sku: "Original SKU",
  change_payment_method: "Change payment method",
  abandon_payment: "Cancel payment attempt",
  continue_payment: "Continue payment",
  payment_taking_longer: "Payment is taking longer than expected",
  payment_preparing_novapay: "Preparing secure payment page…",
  payment_novapay_slow: "Online payment is responding slower than expected.",
  payment_novapay_processing: "Online payment is still processing",
  payment_novapay_processing_body:
    "We have not received a final result from the payment system. Do not pay again to avoid a double charge.",
  payment_novapay_degraded_title: "Online card payment",
  payment_novapay_degraded_state: "Temporarily unavailable in the test environment",
  payment_novapay_degraded_body:
    "Online payment is delaying completion of test payments. Choose another method — your order and items will be kept.",
  payment_novapay_not_live_title: "⚡ Online card payment",
  payment_novapay_not_live_state: "Not activated yet",
  payment_novapay_not_live_body:
    "Online card payment is still being activated. Please pay by FOP bank details for now.",
  payment_novapay_use_fop_fallback: "Pay by FOP bank details",
  payment_retry: "Try again",
  check_payment_status: "Check payment status",
  return_to_order: "Back to order",
  cancel_order: "Cancel order",
  payment_section: "Payment",
  fop_payment_option: "Pay to seller IBAN",
  bank_method_title: "Bank transfer (IBAN)",
  copied_short: "Copied",
  bank_awaiting_confirmation: "Waiting for payment",
  bank_awaiting_body:
    "After you pay, we automatically check incoming funds. Confirmation usually appears within a few minutes.",
  bank_paid_title: "✓ Payment confirmed by the bank",
  bank_paid_body: "",
  bank_pay_via_bank: "🏦 Pay with bank app",
  bank_retry_open: "🏦 Pay with bank app",
  bank_open_full_page: "Open the full payment page",
  bank_create_and_pay: "Create order · {TOTAL} ₴",
  bank_create_reorder: "Create reorder · {TOTAL} ₴",
  reorder_cart_added: "Items from order {STG} were added to the cart",
  reorder_cart_merged: "Cart updated",
  reorder_item_unavailable: "This item is currently unavailable",
  reorder_comment_hint: "The comment from the previous order is not copied automatically.",
  add_order_comment: "💬 Add an order comment",
  pay_after_create: "Pay after creating the order",
  pay_after_create_subcopy: "Payment details available immediately",
  confirm_availability_first: "Confirm availability first",
  confirm_availability_first_subcopy: "A manager will check the items",
  checkout_cta_bank_title: "Create order and pay in the bank app",
  checkout_cta_bank_amount: "To pay: {TOTAL} ₴",
  checkout_cta_confirm_title: "Confirm availability first",
  checkout_cta_confirm_amount: "Create order for {TOTAL} ₴",
  checkout_cta_manager_review_title: "Create order for manager availability check",
  checkout_stock_review_title: "Availability confirmation required",
  checkout_stock_review_body:
    "Some items in the cart need availability confirmation. A manager will check the order before payment.",
  payment_timing_section: "When to pay",
  copy_all_done: "✓ Details copied",
  documents_section: "📄 Documents",
  documents_pending: "Documents have not been generated yet",
  bank_awaiting_stock: "Waiting for availability confirmation",
  bank_awaiting_stock_body:
    "A manager will confirm stock and let you know when you can pay.",
  bank_checking_payment: "Checking payment…",
  bank_still_checking: "Payment is still being checked. This can take a few minutes.",
  bank_refresh_status: "Check payment",
  bank_open_app: "Open bank app",
  bank_handoff_failed: "Could not open the bank app automatically",
  bank_awaiting_credit: "Waiting for the payment to post",
  bank_awaiting_credit_body: "Confirmation usually takes a little time.",
  bank_timeline_created: "Order created",
  bank_timeline_awaiting: "Waiting for payment",
  bank_timeline_confirmed: "Payment confirmed",
  bank_chooser_title: "Choose a bank to pay",
  bank_fixed_method_hint: "Payment goes directly to the seller current account.",
  bank_fixed_method_launch: "Details are passed automatically into the bank app.",
  bank_fixed_method_direct: "Payment goes directly to the seller current account.",
  checkout_contact_delivery: "Contact and delivery",
  checkout_save_to_cabinet: "Save this address in my cabinet",
  save: "Save",
  checkout_add_more: "🔎 Add product",
  checkout_add_order: "Add to your order",
  checkout_add_other: "Add another product",
  creating_order: "Creating order…",
  cart_add_product: "Add product",
  cart_search_placeholder: "🔎 Find a product",
  cart_add_hit: "+ Add",
  cart_added: "✓ Added",
  my_orders: "📦 My orders",
  view_order: "📦 View order",
  compact_referral_title: "🎁 Share «Скарби Азії»",
  compact_referral_body: "Invite friends who also like Asian products.",
  compact_referral_cta: "Invite friends",
  cart_show_all_results: "Show all results",
  amount_to_pay: "Amount due",
  consent_before_start: "Before you start",
  consent_accept_continue: "Agree and continue",
  consent_decline: "I do not agree",
  consent_decline_title: "The store is unavailable without consent",
  consent_decline_body:
    "To place an order you need to accept the terms. You can close the app and come back later.",
  legal_offer_btn: "📄 Public offer",
  legal_privacy_btn: "🔒 Privacy policy",
  fop_send_receipt_manager: "📎 Attach receipt",
  cod_payment_option: "Cash on delivery at Nova Poshta",
  confirm_abandon_processing_title: "Online payment is still processing",
  confirm_abandon_processing_body:
    "If you change payment method now, the previous attempt may still be processing. Do not card-pay again. Continue?",
  confirm_abandon_processing_yes: "Yes, change method",
  confirm_abandon_processing_no: "Cancel",
  reason_label: "Reason",
  write_manager_primary: "Message manager",
  product: "Product",
  checkout: "Checkout",
  success: "Order created",
  success_awaiting_payment: "Awaiting payment",
  success_awaiting_payment_body: "Complete payment so we can start assembling the order.",
  success_verifying_title: "Confirming payment",
  success_verifying_body:
    "We received a return from payment. Checking payment status.",
  success_preparing_title: "Preparing secure payment",
  success_preparing_body: "Creating the payment and opening the secure page.",
  success_paid_title: "Payment confirmed ✓",
  fulfillment_preparing: "Preparing your order for shipment",
  fulfillment_manager_pending: "Awaiting store confirmation",
  fulfillment_order_created: "Order created",
  success_fop_title: "Order created",
  success_fop_status: "Waiting for bank confirmation",
  success_fop_receipt_title: "Receipt sent",
  success_fop_receipt_status: "Awaiting manager verification",
  success_cod_title: "Order confirmed",
  success_cod_status: "Payment on delivery at Nova Poshta.",
  success_cod_payment_row: "Payment on delivery at Nova Poshta.",
  fop_send_receipt: "📎 Attach receipt",
  fop_send_receipt_hint: "Optional — the receipt will be saved on the order.",
  fop_send_receipt_hint_paid: "Optional — the receipt will be saved on the order.",
  fop_after_pay_instruction:
    "After you pay, we automatically check incoming funds. Confirmation usually appears within a few minutes.",
  send_requisites_chat: "✈️ Send details to chat",
  requisites_sent_chat: "✓ Payment details sent to chat",
  request_cancellation: "Request cancellation",
  fop_payment_status_label: "Payment status",
  fop_next_step_manager: "Manager confirmation",
  fop_receipt_sent: "✅ Receipt received",
  fop_awaiting_manager:
    "It helps the manager verify the payment. Payment status changes after the actual bank credit is confirmed.",
  fop_checking_file: "Checking the file…",
  referral_reward_pending:
    "Referral reward stays pending until the order is successfully fulfilled and passes anti-fraud checks.",
  payment_help: "Payment help",
  help_feedback: "Help",
  report_bug: "Report a problem",
  suggest_improvement: "Suggest an improvement",
  feedback_bug_hint: "Briefly describe what happened. We capture technical details automatically.",
  feedback_improve_hint: "Tell us what we can improve.",
  feedback_comment_placeholder: "Your comment (optional for a bug report)",
  feedback_send: "Send",
  feedback_thanks: "Thank you. The report was sent to the manager.",
  feedback_send_fail: "Could not send. Try again.",
  back_to_order: "Back to order",
  category: "Category",
  search: "Search",
  empty_cart: "Cart is empty",
  empty_cart_hint: "Add products from the catalog.",
  to_catalog: "To catalog →",
  promo: "🎁 Promo code",
  promo_placeholder: "Enter promo code",
  apply: "Apply",
  remove: "Remove",
  applied: "Applied",
  promo_invalid: "Invalid promo code.",
  promo_under_min: "Promo applies from {min}. Add more items.",
  delete: "Delete",
  sku: "Store SKU",
  barcode: "Barcode",
  checkout_cta: "Place order",
  continue_shopping: "Continue shopping",
  subtotal: "Subtotal",
  discount: "Discount",
  total: "Total",
  add_to_cart: "+ Add to cart",
  unavailable: "Unavailable",
  out_of_stock: "Out of stock",
  in_cart: "In cart",
  go_cart: "Go",
  to_cart: "In cart · Go",
  countries: "Countries",
  countries_hint: "Asian cuisines and flavors",
  country_filter_meaning: "Filter by cuisine / positioning (not country of manufacture)",
  brand_country_label: "Brand country",
  cuisine_country_label: "Cuisine / positioning",
  active_in_stock: "In stock",
  brand_logo_fallback: "Logo unavailable",
  welcome_back: "Welcome back! Pick your favorites or continue shopping.",
  price_tbd: "Price on request",
  oos: "Temporarily out of stock. We'll notify you when it's back.",
  unpriced: "Price on request — this item cannot be added yet. Contact the manager.",
  brand: "Brand",
  country: "Country",
  weight: "Volume / weight",
  product_code: "SKU",
  lang: "Language",
  lang_ua: "UA",
  lang_en: "EN",
  crosssell_title: "Complete your order",
  recs_show_others: "Show other products",
  crosssell_sub: "These products are often purchased together",
  crosssell_add: "+ Add",
  added_toast: "Added to cart",
  added_btn: "Added ✓",
  pairs_well: "Bought with this",
  may_like: "You may also like",
  recently_viewed: "Recently viewed",
  low_stock: "Low",
  thank_you: "Thank you for your order!",
  manager_soon: "A manager will contact you soon.",
  order_number: "Order number:",
  to_home: "Home",
  write_manager: "✍️ Message manager",
  delete_data: "🗑️ Delete my data",
  delete_ack: "Request received. A manager will process it.",
  catalog_load_fail: "Could not load the store",
  catalog_load_fail_title: "Could not load the store.",
  retry: "Try again",
  loading: "Loading the store…",
  loading_brand_title: "Treasures are near",
  results: "Results",
  nothing_found: "Nothing found",
  nothing_hint: "Try another query: tom yum, ramen, sauce, nori.",
  empty_category: "No products in this category yet",
  empty_category_hint: "Try another category or search.",
  build: "Build",
  catalog: "Catalog",
  phone: "Phone",
  hours: "Hours",
  day_off: "Day off",
  monday: "Monday",
  about: "About store",
  contact_manager: "Contact manager",
  close: "Close",
  call: "Call",
  copied: "Copied ✓",
  copy: "Copy",
  copy_all: "Copy all details",
  copy_manually: "Copy manually",
  new_arrivals: "New arrivals",
  new_arrivals_hint: "Fresh products and new items",
  dropshipping: "Dropshipping",
  dropshipping_hint: "Sell without your own warehouse",
  brands: "Brands",
  brands_hint: "Find by manufacturer",
  cart_cta_go: "In cart: {qty} · Go",
  pay_online: "Pay online",
  pay_bank_transfer: "Pay to seller IBAN",
  pay_cod: "Cash on delivery at the branch",
  pay_online_unavailable: "Online payment is temporarily unavailable. Choose another payment method.",
  brand_search: "Search brands",
  products: "products",
  availability_request: "Ask availability",
  did_you_mean: "Did you mean “{q}”?",
  maybe_sku: "Did you mean SKU {q}?",
  available: "In stock",
  not_available: "Out of stock",
  availability_unknown: "Availability on request",
  checkout_contact: "Contact",
  checkout_payment: "Payment",
  checkout_confirm: "Confirmation",
  next_payment: "Next → Payment",
  next_confirm: "Next → Confirmation",
  first_name: "First name",
  last_name: "Last name",
  city_np: "City (Nova Poshta)",
  warehouse: "Branch",
  note: "Comment",
  optional: "Optional",
  choose_payment: "Choose a payment method",
  fop_payment: "Pay to seller IBAN",
  cod_payment: "Cash on delivery at Nova Poshta",
  cod_hint:
    "Want to save on additional fees?\n\nPay by bank transfer to the sole proprietor account and avoid the separate cash-on-delivery money-transfer fee. When paying on delivery, Nova Poshta charges an additional fee under its current tariffs.",
  novapay_placeholder: "Card payment — coming soon",
  novapay_pay_card: "⚡ Online card payment",
  novapay_sandbox_badge_title: "TEST / SANDBOX · NOT LIVE PAYMENT",
  novapay_sandbox_badge_body: "Sandbox payment only. No real funds are charged.",
  novapay_helper: "Card · Apple Pay · Google Pay",
  novapay_helper_note: "Secure checkout. Available methods depend on your device.",
  recipient: "Recipient",
  delivery: "Delivery",
  payment: "Payment",
  amount: "Amount",
  amount_due: "Amount due",
  submit_order: "Confirm order",
  submitting: "Submitting…",
  clear_cart: "Clear cart",
  clear_cart_title: "Clear the cart?",
  clear_cart_body: "All items will be removed from your cart.",
  clear_cart_confirm: "Clear",
  cancel: "Cancel",
  cart_cleared: "Cart cleared ✓",
  checkout_revalidate_fail:
    "We could not verify current prices and availability. Your cart has been saved. Please try again.",
  try_again: "Try again",
  price_changed_hint: "Price updated from the catalog. Review the new total before confirming.",
  agreement_details: "Details",
  agree: "I agree",
  seller: "Seller",
  tax_id: "Tax ID / EDRPOU",
  bank: "Bank",
  address: "Address",
  working_hours:
    "Business hours: Tue–Sun, 09:00–18:00. Monday — closed. Orders received outside business hours are processed when possible or on the next business day.",
};

export type StoreV2CopyKey = keyof typeof UA;

export function storeV2Copy(lang: StoreV2Lang): Readonly<Record<StoreV2CopyKey, string>> {
  return lang === "en" ? EN : UA;
}

export function t(lang: StoreV2Lang, key: StoreV2CopyKey, vars?: Record<string, string>): string {
  const dict = storeV2Copy(lang);
  let s: string = dict[key];
  if (vars) {
    for (const [k, v] of Object.entries(vars)) {
      s = s.replace(`{${k}}`, v);
    }
  }
  return s;
}
